module.exports = __webpack_public_path__ + "static/8-773dd08ee7272c7a6fe9f79e85febb5e.jpg";